import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.vc-cta__vertical-marquee' ).length ) {
        $( '.vc-cta__vertical-marquee' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            direction: 'ttb',
            height: '100%',
            autoHeight: true,
            drag: 'free',
            gap: '1rem',
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: 0.75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'vc-cta', COMPONENT );
} )( app );
